export default __webpack_public_path__ + "static/B32-e4a397947ce49a7ec28840b7bb214b02.png";